import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { useRef as r, useState as e } from "react";
import i from "dayjs";
import a from "../../assets/calendar-event.svg.js";
import { useClickOutside as m } from "../hooks/useClickOutside.js";
import { ISO_DATE_FORMAT as s } from "../utils/formatDate.js";
import n from "@mui/icons-material/ChevronLeft";
import d from "@mui/joy/Box";
import f from "@mui/joy/Button";
import { DateCalendar as l } from "@mui/x-date-pickers";
const u = ({ value: u2, onChange: h, format: c = "DD.MM.YYYY", views: p, minDate: v, maxDate: x }) => {
  const g = r(null), [D, j] = e(false);
  return m(g, () => j(false)), o(d, { sx: { position: "relative" }, children: [t(f, { startDecorator: t(a, {}), variant: "soft", size: "sm", color: "neutral", endDecorator: t(n, { sx: { width: 18, height: 18, rotate: D ? "90deg" : "-90deg" } }), onClick: () => j((o2) => !o2), children: u2 ? i(u2).format(c) : u2 }), D && t(d, { sx: { position: "absolute", right: 0, borderRadius: "4px", boxShadow: "var(--mui-shadows-8)", background: "white", zIndex: 10, overflow: "hidden" }, children: t(l, { value: i(u2), views: p, minDate: v, maxDate: x, onChange: (o2, t2) => {
    "finish" === t2 && (h(o2.format(s)), j(false));
  }, openTo: p.length ? p[0] : void 0 }) })] });
};
export {
  u as DateDropdown,
  u as default
};
//# sourceMappingURL=DateDropdown.js.map
